
export function valueForKeyPath(keyPath: string[], object: any): unknown {
  let child = object as any
  for (const key of (keyPath as any[])) {
    child = child[key]
  }
  return child
}
